import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function UnsuccessfulPaymentPage() {
  return (
    <main className="section">
      <div className="card">
        <div className="card-body">
          <div className="card-title">Se ha producido un error</div>
          <div className="text-center mt-3">
            <FontAwesomeIcon
              icon="exclamation-triangle"
              style={{ fontSize: "8rem", color: "orangered" }}
            />
          </div>
          <p className="mt-4">
            Se ha producido un error procesando el pago de la recarga. Por
            favor, vuelva a intentar el pago.
          </p>
        </div>
      </div>
    </main>
  );
}
